import { RefObject, useEffect, useState } from 'react';

type ElementSize = {
  width: number;
  height: number;
};

export const useElementSize = (
  elementRef: RefObject<HTMLElement>
): ElementSize => {
  const [size, setSize] = useState<ElementSize>({
    width: 0,
    height: 0,
  });

  useEffect(() => {
    const element = elementRef.current;

    if (!element) return undefined;

    const updateSize = () => {
      const bounds = element.getBoundingClientRect();

      setSize({
        width: Math.max(0, bounds.width),
        height: Math.max(0, bounds.height),
      });
    };

    updateSize();

    const observer = new ResizeObserver(updateSize);
    observer.observe(element);

    return () => observer.disconnect();
  }, [elementRef]);

  return size;
};
